import { render } from "./Entities-ParentsList.vue?vue&type=template&id=8b8a903a&lang=html"
import script from "./Entities-ParentsList.vue?vue&type=script&lang=js"
export * from "./Entities-ParentsList.vue?vue&type=script&lang=js"

import "./Entities-ParentsList.vue?vue&type=style&index=0&id=8b8a903a&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__